import { SnackbarKey } from "notistack";
import Close from "@chemaxon/design-system/icons/Close";
import { IconButton } from "@chemaxon/design-system/iconButton";

export interface Props {
  closeSnackbar: (key?: SnackbarKey | undefined) => void;
}

export function onCloseAction(closeSnackbar: (key?: SnackbarKey) => void) {
  function CloseButton(key: SnackbarKey | undefined) {
    return <SnackbarCloseButton closeSnackbar={() => closeSnackbar(key)} />;
  }

  return CloseButton;
}

export default function SnackbarCloseButton(props: Props) {
  return (
    <IconButton
      onClick={() => {
        props.closeSnackbar();
      }}
      aria-label={"close-snackbar"}
    >
      <Close />
    </IconButton>
  );
}
